import { render, staticRenderFns } from "./IncomeCorrect.vue?vue&type=template&id=00b3e91e&scoped=true&"
import script from "./IncomeCorrect.vue?vue&type=script&lang=js&"
export * from "./IncomeCorrect.vue?vue&type=script&lang=js&"
import style0 from "./IncomeCorrect.vue?vue&type=style&index=0&id=00b3e91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b3e91e",
  null
  
)

export default component.exports